// @flow
/**
 * User: Mike Chung
 * Date: 18/1/2018
 * Time: 9:51 PM
 */

import type {EBadgeQueryCriteria} from "../../../model/ebadge/EBadgeQueryCriteria";
import type {EBadgeQueryFailedAction, EBadgeQueryStartAction, EBadgeQuerySuccessAction, EBadgeQueryThunkAction, EBadgeQueryWarningAction} from "../eBadgeQueryAction";
import EBadge from "../../../model/ebadge/EBadge";
import {findEBadgeByCriteria} from "../../../dao/eBadgeDao";
import type {StoreState} from "../../../reducers/combinedReducers";
import type {Warning} from "../../../reducers/EBadgeQueryReducer";

function eBadgeQueryStartAction(criteria: EBadgeQueryCriteria): EBadgeQueryStartAction {
    return {
        type: "ebadge/QUERY_START_ACTION",
        criteria: Object.assign({}, criteria)
    };
}

export function eBadgeQuerySuccessAction(eBadges: Array<EBadge>, totalResult: number): EBadgeQuerySuccessAction {
    return {
        type: "ebadge/QUERY_SUCCESS_ACTION",
        eBadges: [].concat(eBadges),
        totalResult
    }
}

function eBadgeQueryFailedAction(error: any): EBadgeQueryFailedAction {
    return {
        type: "ebadge/QUERY_FAILED_ACTION",
        error: Object.assign({}, error)
    }
}

function eBadgeQueryWarningAction(warning: Warning): EBadgeQueryWarningAction {
    return {
        type: "ebadge/QUERY_WARNING_ACTION",
        warning: Object.assign({}, warning)
    }
}

export function eBadgeQueryAction(criteria: EBadgeQueryCriteria): EBadgeQueryThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(eBadgeQueryStartAction(criteria));
                if (criteria.page > 200) {
                    criteria.page = 200;
                    dispatch(eBadgeQueryWarningAction({message: "The Page number is over 200. Please refine your search criteria. Below please see the page 200"}));
                }

                let eBadgeQueryResult = await findEBadgeByCriteria(criteria, getState().loginUser.jwt);
                dispatch(eBadgeQuerySuccessAction(eBadgeQueryResult.result, eBadgeQueryResult.totalResult));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(eBadgeQueryFailedAction(e));
        }

    };
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/creators/eBadgeQueryActionCreator.js